import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { InstagramFeed } from '../components/InstagramFeed';
import { Clients } from '../components/Clients';
import { Contact } from '../components/Contact';
export function Home() {
  return <main data-id="element-202" data-mp="1zhxkqdjnmqzd">
      <Hero data-id="element-203" data-mp="1zi7bw4gfr46n" />
      <About data-id="element-204" data-mp="1ziqttl635sko" />
      <Stats data-id="element-205" data-mp="1ziz7hfa191wx" />
      <Services data-id="element-206" data-mp="1zjie3zu8g3vn" />
      <InstagramFeed data-id="element-207" data-mp="1zk1ydn7cv4cu" />
      <Clients data-id="element-208" data-mp="24h0si5r0rbb1" />
      <Contact data-id="element-209" data-mp="24gimihek1ipx" />
    </main>;
}